<template>
  <div class="uprising">{{data}}</div>
</template>

<script>
export default {
  name: 'Uprising',
  props: {
    data: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/mixin';
@import '../assets/styles/colors';

.uprising {
  @include flex(row, center, center);
  position: fixed;
  bottom: -50px;
  left: 0;
  height: 42px;
  border-radius: 2px;
  margin-bottom: 8px;
  margin-left: 8px;
  padding: 0 12px;
  color: $gd-white;
  background-color: $gd-black;
  @include default-shadow(2px);
  transition: bottom 0.5s ease;

  &.show {
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Uprising.vue